export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11573.cb522a8b.jpg";